<h1 mat-dialog-title >{{ 'Write_Reprove' | translate }}</h1>
<div mat-dialog-actions>
  <input matInput placeholder="Justificativa" [(ngModel)]="valueRe">
  <button mat-button [mat-dialog-close]="[true,valueRe]" cdkFocusInitial >{{ 'Confirm' | translate }}</button>
  <button mat-button [mat-dialog-close]="[false]" cdkFocusInitial >{{ 'Cancel' | translate }}</button>
</div>
